import dayjs from 'dayjs'
import { formatCurrency } from '../../helper'
import { SupplierPartField } from '../SupplierPartDrawer'
import { CarahsoftCatalogRow } from './carahsoftTypes'

const dash = '—'
const text = (v: string | number | null | undefined) => (v === null || v === undefined || v === '' ? dash : String(v))
const currency = (v: number | null | undefined) => (v === null || v === undefined ? dash : formatCurrency(v))
const date = (v: string | null | undefined) => (v ? dayjs(v.slice(0, 10)).format('MMM D, YYYY') : dash)

export function carahsoftPartFields(row: CarahsoftCatalogRow): SupplierPartField[] {
  return [
    { label: 'Price ID', value: text(row.priceId) },
    { label: 'Vendor Part Number', value: text(row.vendorPartNumber) },
    { label: 'Carahsoft Part Number', value: text(row.carahsoftPartNumber) },
    { label: 'Vendor ID', value: text(row.vendorId) },
    { label: 'Vendor', value: text(row.vendor) },
    { label: 'Contract ID', value: text(row.contractId) },
    { label: 'Contract', value: text(row.contract) },
    { label: 'Description', value: text(row.description) },
    { label: 'Country of Origin', value: text(row.countryOfOrigin) },
    { label: 'List Price', value: currency(row.listPrice) },
    { label: 'IMPRES Price', value: currency(row.contractPrice) },
    { label: 'Create Date', value: date(row.carahsoftCreateDate) },
    { label: 'Mod Date', value: date(row.carahsoftModDate) },
  ]
}
